module.exports = function tan(arg) {
  //  discuss at: https://locutus.io/php/tan/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: Math.ceil(tan(8723321.4) * 10000000)
  //   returns 1: 54251849

  return Math.tan(arg)
}
